import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  API_STATUS_REQ_CREATE,
  API_STATUS_REQ_CREATE_NUMBER,
  API_STATUS_REQ_UPDATE,
} from '../../services/api';
import {
  changeAssessorEditingValue,
  clearAssessorEditing,
  loadAssessorByCPF,
  loadProgramasAtivos,
  saveAssessorByCPF,
} from '../../store/modules/AssessoresActions';
import { loadAllEmpresas } from '../../store/modules/EmpresasActions';
import { loadAllCooperativas, loadCidadesByEstadoId, loadEstados } from '../../store/modules/LogradouroActions';
import { closeModal } from '../../store/modules/ModalActions';
import { getFormattedCNPJ } from '../../utils/DataFormatUtils';
import {
  getElementID,
  getInputFocusInFocusOutAttr,
} from '../../utils/HTMLUtils';
import { formatDateToISO, getUnmaskedValue } from '../../utils/InputMaskUtils';
import {
  allIsTrue,
  celularIsValid,
  cpfIsValid,
  doubleNameIsValid,
  emailIsValid,
  EMAIL_MAX_LENGTH,
  maskedValueRequiredIsValid,
  NOME_MAX_LENGTH,
  requiredIsValid,
  dateIsValid,
  estadoRequiredIsValid
} from '../../utils/ValidationUtils';
import { CustomTextField } from '../CustomTextField';
import RefreshIcon from '../Icons/RefreshIcon';
import SaveIcon from '../Icons/SaveIcon';
import {
  CPFMaskedInput,
  DateMaskedInput,
  PhoneMaskedInput,
} from '../MaskedInputs';
import NewAutoCompleteField from '../NewAutoCompleteField/NewAutoCompleteField';
import { Col } from './../Col';
import { CustomButton } from './../CustomButton';
import { Row } from './../Row';
import styles from './AssessorEditModal.scss';
import { GenericModalCadastro } from 'components/GenericModal/GenericModalCadastro';
import { NewAutoCompleteFieldEmpresas } from 'components/NewAutoCompleteField/NewAutoCompleteFieldEmpresas';
import { Box, Chip, Typography } from '@material-ui/core';
import FormacaoAcademica from './ModalAcademico';
import { DeleteOutlineOutlined } from '@material-ui/icons';
import { AddIcon } from 'assets/icons/AddIcon';
import { AlturaMenuEnum } from 'components/CustomMultipleSelect/__types';
import { NewAutoCompleteFieldEstados } from 'components/NewAutoCompleteField/NewAutoCompleteFieldEstados';
import { IconInfoBeta } from 'assets/icons/iconInfoBeta';
import { IconMapBeta } from 'assets/icons/iconMapBeta';
import { IconLineBeta } from 'assets/icons/iconLineBeta';

const rootElementId = 'assessor-edit-modal';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  open: false,
  saving: false,
  loading: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  nomeChanged: false,
  celularChanged: false,
  emailChanged: false,
  dataNascimentoChanged: false,
  cpfChanged: false,
  cooperativasChanged: false,
  idEmpresaChanged: false,
  formacoesAcademicas: [],
  situacaoIsChanged: false,
  idProgramasEducacionaisChanged: false,
  focusedFieldName: null,
};
class AssessorEditModal extends Component {
  validations = {
    nomeIsValid: { status: false },
    celularIsValid: { status: false },
    emailIsValid: { status: false },
    dataNascimentoIsValid: { status: false },
    cpfIsValid: { status: false },
    cooperativaIsValid: { status: false },
    loadingCoopIsValid: { status: false },
    programasIsValid: { status: false },
  };

  mapDiploma = {
    0: "Graduação",
    1: "Pós-graduação",
    2: "Mestrado",
    3: "Doutorado",
  };

  mapSituacao = {
    0: "Em andamento",
    1: "Concluída",
  };

  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
    this.props.loadAllCooperativas();
    this.props.loadAllEmpresas();
    this.handleAddFormacaoAcademica = this.handleAddFormacaoAcademica.bind(this);
    this.handleCloseAcademicModal = this.handleCloseAcademicModal.bind(this);
    this.setValue = this.setValue.bind(this);
    this.focusIn = this.focusIn.bind(this);
    this.focusOut = this.focusOut.bind(this);
  }

  handleOpenAcademicModal = () => {
    this.props.changeAssessorEditingValue("formacaoAcademica", -1);
    this.props.changeAssessorEditingValue("situacao", -1);
    this.props.changeAssessorEditingValue("areaEstudo", "");
    this.setState({ open: true });
  };

  handleCloseAcademicModal = () => {
    this.setState({ open: false });
  };

  handleAddFormacaoAcademica = (payloadArray) => {
    this.setState((prev) => ({
      formacoesAcademicas: [...prev.formacoesAcademicas, ...payloadArray],
    }));
    const item = payloadArray[0];
    this.props.changeAssessorEditingValue("formacaoAcademica", item.diploma);
    this.props.changeAssessorEditingValue("situacao", item.situacao);
    this.props.changeAssessorEditingValue("areaEstudo", item.areaEstudo);
  };

  handleDeleteFormacao = (indexToRemove) => {
    this.setState((prev) => ({
      formacoesAcademicas: prev.formacoesAcademicas.filter((_, idx) => idx !== indexToRemove),
    }));
  };

  hasAtLeastOneFormacao() {
    return Array.isArray(this.state.formacoesAcademicas) &&
      this.state.formacoesAcademicas.length > 0;
  }

  buildFormacoes() {
    const { formacoesAcademicas } = this.state;
    if (!Array.isArray(formacoesAcademicas) || formacoesAcademicas.length === 0) {
      return [];
    }
    return formacoesAcademicas.map((f) => ({
      id: f.id ?? null,
      diploma: f.diploma,
      areaEstudo: (f.areaEstudo ?? "Área de estudo não informada").trim(),
      situacao: f.situacao,
    }));
  }

  changeState(newState) {
    this.setState({
      ...this.state,
      ...newState,
    });
  }

  fieldDisabled() {
    return this.state.saving === true || this.state.loading === true
      ? true
      : false;
  }

  reset() {
    this.setState(INITIAL_STATE);
    this.props.clearAssessorEditing();
  }

  componentDidMount() {
    this.props.loadProgramasAtivos();
  }

  componentWillUnmount() {
    this.reset();
  }

  UNSAFE_componentWillMount() {
    if (this.editing()) {
      this.loadAssessor();
    }
  }

  isoToBr = (iso) => {
    if (!iso) return "";
    const [yyyy, mm, dd] = iso.split("-");
    if (!yyyy || !mm || !dd) return iso;
    return `${dd}/${mm}/${yyyy}`;
  };

  getUFByIdEstado(idEstado) {
    const estados = this.props.logradouro.estados.filter(estado => estado.id === idEstado);
    return (estados && estados.length > 0) ? estados[0].sigla : '';
  }

  getEstadoByIdEstado(idEstado) {
    const estados = this.props.logradouro.estados.filter(
      (estado) => estado.id === idEstado
    );
    return estados && estados.length > 0 ? estados[0].nome : '';
  }

  getCidades(uf) {
    if (!uf || uf.length === 0) {
      return [];
    }
    return this.props.logradouro.cidades[uf.toLowerCase()] || [];
  }

  loadCidades(idEstado) {
    if (this.getCidades(this.getUFByIdEstado(idEstado)).length === 0) {
      this.props.loadCidadesByEstadoId(
        idEstado,
        this.getUFByIdEstado(idEstado)
      );
    }
  }

  loadAssessor() {
    this.changeState({
      loading: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });

    this.props.loadAssessorByCPF(
      this.props.cpf,
      () => {
        this.formIsValid(true);

        const backend = this.props.assessores?.assessorEditing ?? {};
        const backendFormacoes = (backend.formacoes ?? []).map(f => ({
          id: f.id ?? null,
          diploma: f.diploma,
          areaEstudo: (f.areaEstudo ?? "Área de estudo não informada").trim(),
          situacao: f.situacao,
        }));
        this.changeState({
          loading: false,
          nomeChanged: true,
          emailChanged: true,
          dataNascimentoChanged: true,
          cpfChanged: true,
          cooperativasChanged: true,
          situacaoIsChanged: true,
          idEmpresaChanged: true,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
          formacoesAcademicas: backendFormacoes,
        });

        this.props.changeAssessorEditingValue(
          "dataNascimento",
          this.isoToBr(backend.dataNascimento)
        );

        const cidadesBackend = Array.isArray(backend.cidades) ? backend.cidades : [];
        const idEstadoFromCities =
          cidadesBackend.find(c => typeof c.idEstado === "number")?.idEstado ?? -1;

        this.props.changeAssessorEditingValue("idEstado", idEstadoFromCities);

        if (idEstadoFromCities > -1) {
          this.loadCidades(idEstadoFromCities);

          const nomesCidades = cidadesBackend
            .filter(c => c && c.idEstado === idEstadoFromCities && (c.nomeCidade ?? "").trim().length > 0)
            .map(c => (c.nomeCidade || "").trim().toUpperCase());

          this.props.changeAssessorEditingValue("cidadesSelecionadas", nomesCidades);

          const estadoNome = this.getEstadoByIdEstado(idEstadoFromCities);
          this.props.changeAssessorEditingValue("estado", estadoNome);
        } else {
          this.props.changeAssessorEditingValue("cidadesSelecionadas", []);
          this.props.changeAssessorEditingValue("estado", "");
        }

        if (!this.props.logradouro.estados || this.props.logradouro.estados.length === 0) {
          this.props.loadEstados(() => {
            if (idEstadoFromCities > -1) {
              this.loadCidades(idEstadoFromCities);
            }
          });
        }

        if (this.hasMissingLocationFields()) {
          const estadoEl = document.getElementById(getElementID(rootElementId, 'estado'));
          if (estadoEl && typeof estadoEl.scrollIntoView === 'function') {
            estadoEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          window.setTimeout(() => {
            const input = estadoEl?.querySelector('input');
            if (input && typeof input.focus === 'function') {
              input.focus();
            }
          }, 250);

          this.setState({
            estadoChanged: true,
            cidadeChanged: true,
          });
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadAssessorEditing,
          options: { variant: 'error' },
        });

        if (!this.props.logradouro.estados || this.props.logradouro.estados.length === 0) {
          this.props.loadEstados(() => {
            const idEstadoFromCities =
              this.props.assessores.assessorEditing.idEstado ?? -1;
            if (idEstadoFromCities > -1) {
              this.loadCidades(idEstadoFromCities);
            }
          });
        }

        this.toClose();
      }
    );
  }

  getTitle() {
    if (this.editing()) {
      return this.props.languageValues.editAssessorModalTitle;
    }
    return this.props.languageValues.newAssessorModalTitle;
  }

  hasMissingLocationFields() {
    const idEstado = Number(this.props.assessores?.assessorEditing?.idEstado ?? -1);
    const cidades = this.props.assessores?.assessorEditing?.cidadesSelecionadas ?? [];
    const semEstado = idEstado < 0;
    const semCidade = !Array.isArray(cidades) || cidades.length === 0;
    return semEstado || semCidade;
  }

  getWarningMessage() {
    if (this.editing() && this.hasMissingLocationFields()) {
      return (
        <Box className={rootClassName + "-info-card"}>
          <div className={rootClassName + "-info-header"}>
            <IconInfoBeta />
            <Typography
              variant="h6"
              className={rootClassName + "-info-title"}
            >
              Precisamos de algumas informações!
            </Typography>
          </div>
          <Typography
            variant="body2"
            className={rootClassName + "-info-text"}
          >
            Antes de continuar, precisamos que você complete algumas informações que estão faltando.
            Isso ajuda nossa equipe a oferecer experiências melhores e mais personalizadas. É rapidinho!
          </Typography>
        </Box>
      );
    }
    return null;
  }

  getNotificationOfUnfilledFields() {
    if (this.editing() && this.hasMissingLocationFields()) {
      return (
        <Row className={rootElementId + "-row-location"}>
          <div className={rootElementId + "-location-icon"}>
            <IconMapBeta />
          </div>

          <div className={rootElementId + "-location-line"}>
            <IconLineBeta color="#FACCDC" height={1} />
          </div>

          <Typography className={rootElementId + "-location-text"}>
            Campos para atualizar
          </Typography>

          <div className={rootElementId + "-location-line"}>
            <IconLineBeta color="#FACCDC" height={1} />
          </div>
        </Row>
      );
    }
    return null;
  }

  getSubmitLabel() {
    if (this.editing()) {
      return this.props.languageValues.salvar;
    }
    return this.props.languageValues.cadastrar;
  }

  setValue(event) {
    this.setState({
      ...this.state,
      [event.target.name + 'Changed']: true,
    });
    return this.props.changeAssessorEditingValue(
      event.target.name,
      event.target.value
    );
  }

  simpleValidation(value) {
    return value && value.length > 0 ? true : false;
  }

  nomeIsValid(force) {
    if (force || this.state.focusedFieldName === 'nome') {
      const value = this.props.assessores.assessorEditing.nome;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.nome.required
      );
      const validation = doubleNameIsValid(
        value,
        this.props.languageValues.validations.nome.validation
      );
      if (!required.status) {
        this.validations.nomeIsValid = required;
        return required;
      }
      if (!validation.status) {
        this.validations.nomeIsValid = validation;
        return validation;
      }
      this.validations.nomeIsValid = {
        status: true,
      };
      return this.validations.nomeIsValid;
    } else {
      return this.validations.nomeIsValid;
    }
  }

  programasIsValid() {
    const programasEducacionais =
      this.props.assessores.assessorEditing.programasEducacionais;
    return programasEducacionais && programasEducacionais.length > 0
      ? { status: true }
      : {
        status: false,
        error:
          this.props.languageValues.validations.idProgramasEducacionais
            .required,
      };
  }

  celularValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'celular') {
      const value = this.props.assessores.assessorEditing.celular;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.celular.required
      );
      const length = celularIsValid(
        value,
        this.props.languageValues.validations.celular.length
      );
      if (!required.status) {
        this.validations.celularIsValid = required;
        return this.validations.celularIsValid;
      }
      if (!length.status) {
        this.validations.celularIsValid = length;
        return this.validations.celularIsValid;
      }
      this.validations.celularIsValid = {
        status: true,
      };
      return this.validations.celularIsValid;
    } else {
      return this.validations.celularIsValid;
    }
  }

  dataNascimentoIsValid(force) {
    if (force || this.state.focusedFieldName === 'dataNascimento') {
      const value = this.props.assessores.assessorEditing.dataNascimento;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.birthDate.required
      );
      const validation = dateIsValid(
        value,
        this.props.languageValues.validations.birthDate.validation
      );
      if (!required.status) {
        this.validations.dataNascimentoIsValid = required;
        return this.validations.dataNascimentoIsValid;
      }
      if (!validation.status) {
        this.validations.dataNascimentoIsValid = validation;
        return this.validations.dataNascimentoIsValid;
      }
      this.validations.dataNascimentoIsValid = {
        status: true,
      };
      return this.validations.dataNascimentoIsValid;
    } else {
      return this.validations.dataNascimentoIsValid;
    }
  }

  emailValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'email') {
      const value = this.props.assessores.assessorEditing.email;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.email.required
      );
      const validation = emailIsValid(
        value,
        this.props.languageValues.validations.email.validation
      );
      if (!required.status) {
        this.validations.emailIsValid = required;
        return this.validations.emailIsValid;
      }
      if (!validation.status) {
        this.validations.emailIsValid = validation;
        return this.validations.emailIsValid;
      }
      this.validations.emailIsValid = {
        status: true,
      };
      return this.validations.emailIsValid;
    } else {
      return this.validations.emailIsValid;
    }
  }

  cpfValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'cpf') {
      const value = this.props.assessores.assessorEditing.cpf;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.cpf.required
      );
      const validation = cpfIsValid(
        value,
        this.props.languageValues.validations.cpf.validation
      );
      if (!required.status) {
        this.validations.cpfIsValid = required;
        return this.validations.cpfIsValid;
      }
      if (!validation.status) {
        this.validations.cpfIsValid = validation;
        return this.validations.cpfIsValid;
      }
      this.validations.cpfIsValid = {
        status: true,
      };
      return this.validations.cpfIsValid;
    } else {
      return this.validations.cpfIsValid;
    }
  }

  cooperativaIsValid() {
    return this.props.assessores.assessorEditing.cooperativas.length > 0
      ? {
        status: true,
      }
      : {
        status: false,
        error: this.props.languageValues.validations.cooperativas.required,
      };
  }

  idSituacaoIsValid() {
    const situacao =
      this.props.assessores.assessorEditing.situacao;
    if (situacao >= 0) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
        error:
          this.props.languageValues.validations.situacao.required,
      };
    }
  }

  estadoValueIsValid() {
    const required = estadoRequiredIsValid(
      this.props.assessores.assessorEditing.idEstado,
      this.props.languageValues.validations.estado.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  cidadeFieldIsDisabled() {
    return this.props.logradouro.loadingCidades ||
      this.props.assessores.assessorEditing.idEstado === -1
      ? true
      : false;
  }

  cidadeValueIsValid() {
    const arr = this.props.assessores.assessorEditing.cidadesSelecionadas || [];
    const ok = Array.isArray(arr) && arr.length > 0;
    if (!ok) {
      return {
        status: false,
        error: this.props.languageValues.validations.cidade.required,
      };
    }
    return { status: true };
  }

  buildCidades(editing) {
    const idEstado = Number(editing?.idEstado ?? -1);
    const cidadesSelecionadas = Array.isArray(editing?.cidadesSelecionadas)
      ? editing.cidadesSelecionadas
      : [];

    if (idEstado < 0 || cidadesSelecionadas.length === 0) {
      return [];
    }

    const nomesNormalizadosUnicos = Array.from(
      new Set(
        cidadesSelecionadas
          .map((n) => (n ?? '').trim().toUpperCase())
          .filter((n) => n.length > 0)
      )
    );
    return nomesNormalizadosUnicos.map((nome) => ({
      idEstado,
      nomeCidade: nome,
    }));
  }

  processing() {
    return this.state.sending || this.state.loading ? true : false;
  }

  formIsValid(force) {
    const arr = [
      this.nomeIsValid(force).status,
      this.celularValueIsValid(force).status,
      this.dataNascimentoIsValid(force).status,
      this.emailValueIsValid(force).status,
      this.editing() ? true : this.cpfValueIsValid(force).status,
      this.cooperativaIsValid().status,
      this.cidadeValueIsValid().status,
      this.programasIsValid().status,
    ];
    return allIsTrue(arr);
  }

  editing() {
    return this.props.cpf ? true : false;
  }

  toSubmit() {
    if (!this.formIsValid()) {
      return false;
    }

    this.changeState({
      saving: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });

    const editing = this.props.assessores.assessorEditing;

    this.props.saveAssessorByCPF(
      {
        celular: getUnmaskedValue(
          editing.celular
        ),
        cpf: getUnmaskedValue(this.props.assessores.assessorEditing.cpf),
        dataNascimento: formatDateToISO(
          editing.dataNascimento
        ),
        email: editing.email.trim(),
        cooperativas: editing.cooperativas,
        programasEducacionais:
          editing.programasEducacionais,
        formacoes: this.buildFormacoes(editing),
        cidades: this.buildCidades(editing),
        cooperativasGestor:
          editing.cooperativasGestor,
        idEmpresa:
          editing.idEmpresa &&
            editing.idEmpresa > -1
            ? editing.idEmpresa
            : null,
        nome: editing.nome.trim(),
        status: API_STATUS_REQ_CREATE_NUMBER,
        statusReq: this.editing()
          ? API_STATUS_REQ_UPDATE
          : API_STATUS_REQ_CREATE,
        idUsuario: this.props.auth.userData.profile.id
      },
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.editing()
            ? this.props.languageValues.successSalvarAssessor
            : this.props.languageValues.successCadastrarAssessor,
          options: {
            variant: 'success',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
        if (typeof this.props.savedCallback === 'function') {
          this.props.savedCallback();
        }
        this.toClose();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message: error.response.statusText
            ? error.response.statusText
            : this.editing()
              ? this.props.languageValues.erroSalvarAssessor
              : this.props.languageValues.erroCadastrarAssessor,
          options: {
            variant: 'error',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
      }
    );
  }

  toClose() {
    this.props.closeModal(this.props.modalKey);
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  focusIn(fieldName) {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  }

  focusOut(fieldName) {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  }

  allowEdit() {
    return this.props.auth.userPermissions.assessores.edit;
  }

  atualizarCooperativasGestor = () => {
    const cooperativas = this.props.assessores.assessorEditing.cooperativas;
    const cooperativasGestor =
      this.props.assessores.assessorEditing.cooperativasGestor;
    const cooperativasGestorForaDeCooperativas = cooperativasGestor.filter(
      (item) => {
        return cooperativas.indexOf(item) === -1;
      }
    );
    if (cooperativasGestorForaDeCooperativas.length > 0) {
      this.setValue({
        target: {
          name: 'cooperativasGestor',
          value: cooperativasGestor.filter((item) => {
            return cooperativas.indexOf(item) > -1;
          }),
        },
      });
    }
  };

  getCooperativasGestor = () => {
    return this.props.logradouro.allCooperativas
      .filter((item) => {
        return (
          this.props.assessores.assessorEditing.cooperativas.indexOf(
            item.codigo
          ) > -1
        );
      })
      .map((item) => {
        return {
          label: item.nome,
          value: item.codigo,
        };
      });
  };

  getFormacoesAcademicas() {
    const { formacoesAcademicas } = this.state;
    if (!formacoesAcademicas || formacoesAcademicas.length === 0) {
      return (
        <Typography variant="caption" style={{ color: "#E60050" }}>
          *Adicione pelo menos uma formação acadêmica
        </Typography>
      );
    }

    return (
      <Box display="flex" flexWrap="wrap">
        {formacoesAcademicas.map((item, idx) => {
          const label =
            `${this.mapDiploma[item.diploma] ?? item.diploma} • ` +
            `${this.mapSituacao[item.situacao] ?? item.situacao} • ` +
            `${item.areaEstudo}`;
          return (
            <Chip
              key={item.id ?? idx}
              label={label}
              color="default"
              variant="outlined"
              style={{ marginRight: 8, backgroundColor: "#47d6ff", color: "#ffff", border: "none" }}
              onDelete={() => this.handleDeleteFormacao(idx)}
              deleteIcon={<DeleteOutlineOutlined style={{ display: "flex", alignContent: "center", width: 18, height: 18, color: "#AA003C" }} />}
            />
          );
        })}
      </Box>
    );
  }

  render() {
    const { programas } = this.props;
    return (
      <GenericModalCadastro
        key={this.props.key}
        id={rootElementId}
        onClose={() => {
          this.toClose();
        }}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: this.state.disableBackdropClick,
          disableEscapeKeyDown: this.state.disableEscapeKeyDown,
        }}
        title={
          <>
            {this.getTitle()}
            {this.state.loading || this.state.saving ? (
              <RefreshIcon className={rootClassName + '-loading-icon'} />
            ) : null}
          </>
        }
        footerContent={
          <>
            <Row>
              <Col cols={[12, 6, 6, 6, 6]} className='col-legend'>
                <div className='legend'>
                  {this.props.languageValues.campoObrigatorio}
                </div>
              </Col>
            </Row>
            <Row>
              <Col cols={[12, 12, 6, 6, 5]}>
                <CustomButton
                  id={getElementID(rootElementId, 'cancel')}
                  theme='pufvYellow'
                  className={rootClassName + '-cancel-button'}
                  label={this.props.languageValues.cancelButton}
                  onClick={() => this.toClose()}
                />
              </Col>
              <Col cols={[12, 12, 6, 6, 4]}>
                <CustomButton
                  id={getElementID(rootElementId, 'save')}
                  theme='pufvYellow'
                  className={rootClassName + '-save-buttom'}
                  label={this.getSubmitLabel()}
                  disabled={
                    this.state.loading ||
                    this.state.saving ||
                    !this.formIsValid() ||
                    !this.hasAtLeastOneFormacao()
                  }
                  rightIcon={<SaveIcon />}
                  type='submit'
                />
              </Col>
            </Row>
          </>
        }
        onSubmit={(event) => {
          event.preventDefault();
          this.toSubmit();
        }}
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            {this.getWarningMessage()}
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'nome')}
              label={this.props.languageValues.cadastroAssessorNome}
              name='nome'
              value={this.props.assessores.assessorEditing.nome || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={NOME_MAX_LENGTH}
              helperText={
                this.state.nomeChanged && !this.nomeIsValid().status
                  ? this.nomeIsValid().error
                  : ''
              }
              error={this.state.nomeChanged && !this.nomeIsValid().status}
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'email')}
              label={this.props.languageValues.cadastroAssessorEmail}
              name='email'
              value={this.props.assessores.assessorEditing.email || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={EMAIL_MAX_LENGTH}
              helperText={
                this.state.emailChanged && !this.emailValueIsValid().status
                  ? this.emailValueIsValid().error
                  : ''
              }
              error={
                this.state.emailChanged && !this.emailValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'data-nascimento')}
              label={this.props.languageValues.cadastroAssessorDataNascimento}
              name='dataNascimento'
              value={this.props.assessores.assessorEditing.dataNascimento || ''}
              onChange={(event) => this.setValue(event)}
              helperText={
                this.state.dataNascimentoChanged && !this.dataNascimentoIsValid(true).status
                  ? this.dataNascimentoIsValid(true).error
                  : ''
              }
              error={
                this.state.dataNascimentoChanged && !this.dataNascimentoIsValid(true).status
              }
              disabled={this.fieldDisabled()}
              InputProps={{ inputComponent: DateMaskedInput }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'celular')}
              label={this.props.languageValues.cadastroAssessorCelular}
              name='celular'
              value={this.props.assessores.assessorEditing.celular || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                this.state.celularChanged && !this.celularValueIsValid().status
                  ? this.celularValueIsValid().error
                  : ''
              }
              error={
                this.state.celularChanged && !this.celularValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              InputProps={{
                inputComponent: PhoneMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'cpf')}
              label={this.props.languageValues.cadastroAssessorCPF}
              name='cpf'
              value={this.props.assessores.assessorEditing.cpf || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                !this.editing() &&
                  this.state.cpfChanged &&
                  !this.cpfValueIsValid().status
                  ? this.cpfValueIsValid().error
                  : ''
              }
              error={
                !this.editing() &&
                this.state.cpfChanged &&
                !this.cpfValueIsValid().status
              }
              disabled={this.editing() || this.fieldDisabled()}
              InputProps={{
                inputComponent: CPFMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'programasEducacionais')}
                label={this.props.languageValues.cadastroAssessorProgramas}
                options={
                  programas
                    ? programas.map((programa) => ({
                      label: programa.nomePrograma,
                      value: programa.tipoPrograma,
                    }))
                    : []
                }
                value={
                  this.props.assessores.assessorEditing.programasEducacionais
                }
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'programasEducacionais',
                      value: currValue,
                    },
                  });
                }}
                multiple
                loading={this.props.empresas.loadingAllList}
                loadingMessage={this.props.languageValues.loadingProgramas}
                error={
                  this.state.cooperativasChanged &&
                  !this.programasIsValid().status
                }
                helperText={
                  this.state.cooperativasChanged &&
                    !this.programasIsValid().status
                    ? this.programasIsValid().error
                    : ''
                }
                disabled={
                  this.fieldDisabled() || this.props.empresas.loadingAllList
                }
              />
            </Col>
          </Row>
        ) : null}

        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'cooperativas')}
                label={this.props.languageValues.cadastroAssessorCooperativa}
                placeholder={
                  this.props.logradouro.loadingAllCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.props.logradouro.allCooperativas.map((item) => {
                  return {
                    label: item.nome,
                    value: item.codigo,
                  };
                })}
                value={this.props.assessores.assessorEditing.cooperativas}
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'cooperativas',
                      value: currValue,
                    },
                  }).then(this.atualizarCooperativasGestor);
                }}
                multiple
                loading={this.props.logradouro.loadingAllCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                error={
                  this.state.cooperativasChanged &&
                  !this.cooperativaIsValid().status
                }
                helperText={
                  this.state.cooperativasChanged &&
                    !this.cooperativaIsValid().status
                    ? this.cooperativaIsValid().error
                    : ''
                }
                disabled={
                  this.fieldDisabled() ||
                  this.props.logradouro.loadingAllCooperativas
                }
              />
            </Col>
          </Row>
        ) : null}

        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'cooperativas-gestor')}
                label={
                  this.props.languageValues.cadastroAssessorCooperativaGestor
                }
                placeholder={
                  this.props.logradouro.loadingAllCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.getCooperativasGestor()}
                value={
                  this.props.assessores.assessorEditing.cooperativasGestor || []
                }
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'cooperativasGestor',
                      value: currValue,
                    },
                  });
                }}
                multiple
                loading={this.props.logradouro.loadingAllCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                disabled={
                  this.fieldDisabled() ||
                  this.props.logradouro.loadingAllCooperativas
                }
              />
            </Col>
          </Row>
        ) : null}

        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <button
              id="add-formacao"
              type='button'
              className="add-formacao"
              variant="contained"
              style={{
                backgroundColor: "#ffeb8c",
                borderRadius: 20,
                width: "auto",
                height: "auto",
                fontSize: 14,
                padding: 7
              }}
              onClick={() =>
                this.handleOpenAcademicModal()}
              disabled={this.fieldDisabled()}
            >
              Adicionar formações acadêmicas <AddIcon />
            </button>
          </Col>
        </Row>

        {this.state.open && (
          <FormacaoAcademica
            open={this.state.open}
            onClose={this.handleCloseAcademicModal}
            assessorEditing={this.props.assessores.assessorEditing}
            onChangeField={(name, value) => {
              this.setValue({ target: { name, value } });
            }}
            onAdd={this.handleAddFormacaoAcademica}
            disableBackdropClick={this.state.disableBackdropClick}
            disableEscapeKeyDown={this.state.disableEscapeKeyDown}
          />
        )}

        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <Box>
              <Typography variant="body1" style={{ fontSize: 12, fontWeight: 500 }}>
                Formações cadastradas:
              </Typography>
              {this.getFormacoesAcademicas()}
            </Box>
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteFieldEmpresas
              id={getElementID(rootElementId, 'idEmpresa')}
              label={this.props.languageValues.cadastroAssessorEmpresa}
              placeholder={
                this.props.empresas.loadingAllList
                  ? this.props.languageValues.loadingEmpresas
                  : ''
              }
              options={this.props.empresas.allList.map((item) => {
                return {
                  label: getFormattedCNPJ(item.cnpjEmpresa) + ' - ' + item.nome,
                  value: item.id,
                };
              })}
              value={this.props.assessores.assessorEditing.idEmpresa || -1}
              onChange={(value) => {
                const currValue = value ? value.value : -1;
                this.setValue({
                  target: {
                    name: 'idEmpresa',
                    value: currValue,
                  },
                });
              }}
              loading={this.props.empresas.loadingAllList}
              loadingMessage={this.props.languageValues.loadingEmpresas}
              disabled={
                this.fieldDisabled() || this.props.empresas.loadingAllList
              }
            />
          </Col>
        </Row>

        <Row>
          {this.getNotificationOfUnfilledFields()}

          <Col cols={[12, 6, 6, 6, 6]}>
            <NewAutoCompleteFieldEstados
              id={getElementID(rootElementId, 'estado')}
              label={this.props.languageValues.cadastroCoordenadorEstado}
              placeholder={
                this.props.logradouro.loadingEstados
                  ? this.props.languageValues.loadingEstados
                  : ''
              }
              options={this.props.logradouro.estados.map((item) => ({
                label: item.nome,
                value: item.id,
                sigla: item.sigla,
              }))}
              value={this.props.assessores.assessorEditing.idEstado}
              onChange={(value) => {
                const currValue = value && value.value > -1 ? value.value : -1;
                this.setValue({ target: { name: 'idEstado', value: currValue } });
                this.setValue({ target: { name: 'estado', value: value && value.value > -1 ? value.label : '' } });
                this.setValue({ target: { name: 'cidadesSelecionadas', value: [] } });
                window.setTimeout(() => {
                  this.setValue({ target: { name: 'idEstado', value: currValue } });
                }, 1);

                if (currValue > -1) {
                  this.loadCidades(currValue);
                }
              }}
              loading={this.props.logradouro.loadingEstados}
              loadingMessage={this.props.languageValues.loadingEstados}
              disabled={this.fieldDisabled() || this.props.logradouro.loadingEstados}
              error={this.state.estadoChanged && !this.estadoValueIsValid().status}
              helperText={
                this.state.estadoChanged && !this.estadoValueIsValid().status
                  ? this.estadoValueIsValid().error
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 6, 6, 6, 6]}>
            <NewAutoCompleteField
              id={getElementID(rootElementId, 'cidade')}
              label={this.props.languageValues.cadastroCoordenadorCidade}
              placeholder={
                this.props.logradouro.loadingCidades
                  ? this.props.languageValues.loadingCidades
                  : ''
              }
              multiple
              options={this.getCidades(
                this.getUFByIdEstado(this.props.assessores.assessorEditing.idEstado)
              ).map((item) => ({
                label: item.nome,
                value: item.nome,
              }))}
              value={this.props.assessores.assessorEditing.cidadesSelecionadas || []}
              onChange={(selectedOptions) => {
                const nomes = Array.isArray(selectedOptions)
                  ? selectedOptions
                    .map((opt) => (opt?.value || '').trim().toUpperCase())
                    .filter((v) => v.length > 0)
                  : [];
                this.setValue({
                  target: {
                    name: 'cidadesSelecionadas',
                    value: nomes,
                  },
                });
              }}
              loading={this.props.logradouro.loadingCidades}
              loadingMessage={this.props.languageValues.loadingCidades}
              disabled={this.cidadeFieldIsDisabled() || this.fieldDisabled()}
              helperText={
                this.state.cidadeChanged && !this.cidadeValueIsValid().status
                  ? this.cidadeValueIsValid().error
                  : ''
              }
              error={this.state.cidadeChanged && !this.cidadeValueIsValid().status}
              menuMaxHeight={{
                desktop: AlturaMenuEnum.ss,
                tablet: AlturaMenuEnum.ss,
                mobile: AlturaMenuEnum.ss
              }}
            />
          </Col>
        </Row>
      </GenericModalCadastro>
    );
  }
}

AssessorEditModal.propTypes = {
  cpf: PropTypes.string,
  modalKey: PropTypes.string.isRequired,
  savedCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  assessores: state.assessores,
  logradouro: state.logradouro,
  empresas: state.empresas,
  auth: state.auth,
  programas: state.assessores.programas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeAssessorEditingValue,
      loadAllCooperativas,
      clearAssessorEditing,
      closeModal,
      loadAssessorByCPF,
      saveAssessorByCPF,
      loadAllEmpresas,
      loadProgramasAtivos,
      loadEstados,
      loadCidadesByEstadoId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AssessorEditModal);
